<template>
    <div>
        <TopNavBar navtitle="查看考生评语"></TopNavBar>
        <van-button type="primary" v-if="ERT_Name != '' && !IsMusicTheory" @click="printTable">打印评语</van-button>
        <table class="SRcontainer" style="border-collapse: collapse" border="1" v-if="!IsMusicTheory">
            <tbody>
                <tr style="">
                    <td style="text-align: center" colspan="10" class="SRht">中国音协音乐考级委员会{{ UserInfo ? UserInfo.Majors.MName : '' }}考级评审表</td>
                </tr>
                <tr style="">
                    <td style="width: 12%">考生姓名</td>
                    <td style="width: 21.3%" colspan="3">{{ UserInfo ? UserInfo.Name : '' }}</td>
                    <td style="width: 12%">准考证号</td>
                    <td style="width: 21.3%" colspan="2">{{ UserInfo ? UserInfo.ExamNO : '' }}</td>
                    <td style="width: 12%">报考等级</td>
                    <td style="width: 21.3%" colspan="2">{{ UserInfo ? UserInfo.Grades.GName : '' }}</td>
                </tr>
                <tr class="sitem">
                    <td class="SRtitle">考评项目</td>
                    <td class="SRtitle" colspan="4">综合评价</td>
                    <td class="SRtitle" colspan="5">主要优缺点</td>
                </tr>
                <!-- 曲目评价 -->
                <tr class="sitem" v-for="(item, index) in resultList.ExamAnswerSheets" :key="index">
                    <td class="SRtitle">{{ item.ExamQuestionType.TypeName }}</td>
                    <td class="w7">
                        好
                        <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['好']" />
                    </td>
                    <td class="w7">
                        较好
                        <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['较好']" />
                    </td>
                    <td class="w7">
                        尚可
                        <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['尚可']" />
                    </td>
                    <td class="w7">
                        较差
                        <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['较差']" />
                    </td>
                    <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['好']">
                        {{ resultList.Judgement[item.EAS_ID]['好'].join(',')
                        }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                    </td>
                    <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['较好']">
                        {{ resultList.Judgement[item.EAS_ID]['较好'].join(',')
                        }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                    </td>
                    <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['尚可']">
                        {{ resultList.Judgement[item.EAS_ID]['尚可'].join(',')
                        }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                    </td>
                    <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['较差']">
                        {{ resultList.Judgement[item.EAS_ID]['较差'].join(',')
                        }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                    </td>
                </tr>
                <tr style="height: 120px">
                    <td>意见与建议</td>
                    <td colspan="9">
                        {{
                            resultList.Judgement && resultList.Judgement['意见建议'] && resultList.Judgement['意见建议']['意见与建议']
                                ? resultList.Judgement['意见建议']['意见与建议'].join(',')
                                : ''
                        }}{{ resultList.Suggestion }}
                    </td>
                </tr>

                <tr>
                    <td>综审意见</td>
                    <td style="text-align: left" colspan="7">{{ ERT_Name }}</td>
                    <td style="text-align: center" colspan="2">
                        {{
                            resultList.CreateTime ? `${new Date(resultList.CreateTime).getFullYear()}年${new Date(resultList.CreateTime).getMonth() + 1}月` : ''
                        }}
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- 听力分数展示 -->
        <table class="SRcontainer" style="border-collapse: collapse" border="1" v-else>
            <tbody>
                <tr style="">
                    <td style="text-align: center" colspan="10" class="SRht">中国音协音乐考级委员会音乐听力评审表</td>
                </tr>
                <tr style="">
                    <td style="width: 12%">考生姓名</td>
                    <td style="width: 21.3%" colspan="3">{{ UserInfo ? UserInfo.Name : '' }}</td>
                    <td style="width: 12%">准考证号</td>
                    <td style="width: 21.3%" colspan="2">{{ UserInfo ? UserInfo.ExamNO : '' }}</td>
                    <td style="width: 12%">报考等级</td>
                    <td style="width: 21.3%" colspan="2">{{ UserInfo ? UserInfo.Grades.GName : '' }}</td>
                </tr>
                <tr class="sitem">
                    <td class="SRtitle" colspan="3">题号</td>
                    <td class="SRtitle" colspan="2">得分</td>
                    <td class="SRtitle" colspan="3">题号</td>
                    <td class="SRtitle" colspan="2">得分</td>
                </tr>
                <tr class="sitem" v-for="index in Math.ceil(ScoreList.length / 2)" :key="index">
                    <td class="SRtitle" colspan="3">第{{ chin_list[index * 2 - 2] }}题</td>
                    <td class="SRtitle" colspan="2">{{ ScoreList[index * 2 - 2].Score }}</td>
                    <td class="SRtitle" colspan="3" v-if="index * 2 - 1 < ScoreList.length">第{{ chin_list[index * 2 - 1] }}题</td>
                    <td class="SRtitle" colspan="2" v-if="index * 2 - 1 < ScoreList.length">{{ ScoreList[index * 2 - 1].Score }}</td>
                </tr>
                <tr>
                    <td colspan="3">总分</td>
                    <td colspan="7">{{ SumScore }}</td>
                </tr>

                <tr>
                    <td colspan="3">综审意见</td>
                    <td style="text-align: left" colspan="3">{{ ERT_Name }}</td>
                    <td style="text-align: center" colspan="4">
                        {{
                            resultList.CreateTime ? `${new Date(resultList.CreateTime).getFullYear()}年${new Date(resultList.CreateTime).getMonth() + 1}月` : ''
                        }}
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- 评语打印 -->
        <div id="printTable" style="width: 960px; display: none; background-color: #fff" v-if="!IsMusicTheory">
            <table class="SRcontainer" style="border-collapse: collapse" border="1">
                <tbody>
                    <tr style="">
                        <td style="text-align: center" colspan="10" class="SRht">
                            中国音协音乐考级委员会{{ UserInfo ? UserInfo.Majors.MName : '' }}考级评审表
                        </td>
                    </tr>
                    <tr style="">
                        <td style="width: 12%">考生姓名</td>
                        <td style="width: 21.3%" colspan="3">{{ UserInfo ? UserInfo.Name : '' }}</td>
                        <td style="width: 12%">准考证号</td>
                        <td style="width: 21.3%" colspan="2">{{ UserInfo ? UserInfo.ExamNO : '' }}</td>
                        <td style="width: 12%">报考等级</td>
                        <td style="width: 21.3%" colspan="2">{{ UserInfo ? UserInfo.Grades.GName : '' }}</td>
                    </tr>
                    <tr class="sitem">
                        <td class="SRtitle">考评项目</td>
                        <td class="SRtitle" colspan="4">综合评价</td>
                        <td class="SRtitle" colspan="5">主要优缺点</td>
                    </tr>
                    <!-- 曲目评价 -->
                    <tr class="sitem" v-for="(item, index) in resultList.ExamAnswerSheets" :key="index">
                        <td class="SRtitle">{{ item.ExamQuestionType.TypeName }}</td>
                        <td class="w7">
                            好<br />
                            <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['好']" />
                        </td>
                        <td class="w7">
                            较好<br />
                            <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['较好']" />
                        </td>
                        <td class="w7">
                            尚可<br />
                            <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['尚可']" />
                        </td>
                        <td class="w7">
                            较差<br />
                            <van-icon name="passed" v-if="resultList.Judgement[item.EAS_ID]['较差']" />
                        </td>
                        <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['好']">
                            {{ resultList.Judgement[item.EAS_ID]['好'].join(',')
                            }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                        </td>
                        <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['较好']">
                            {{ resultList.Judgement[item.EAS_ID]['较好'].join(',')
                            }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                        </td>
                        <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['尚可']">
                            {{ resultList.Judgement[item.EAS_ID]['尚可'].join(',')
                            }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                        </td>
                        <td class="w7" colspan="5" v-if="resultList.Judgement[item.EAS_ID]['较差']">
                            {{ resultList.Judgement[item.EAS_ID]['较差'].join(',')
                            }}{{ resultList.Judgement[item.EAS_ID]['补充意见'] ? resultList.Judgement[item.EAS_ID]['补充意见'] : '' }}
                        </td>
                    </tr>
                    <tr style="height: 120px">
                        <td>意见与建议</td>
                        <td colspan="9">
                            {{
                                resultList.Judgement && resultList.Judgement['意见建议'] && resultList.Judgement['意见建议']['意见与建议']
                                    ? resultList.Judgement['意见建议']['意见与建议'].join(',')
                                    : ''
                            }}{{ resultList.Suggestion }}
                        </td>
                    </tr>

                    <tr>
                        <td>综审意见</td>
                        <td style="text-align: left" colspan="7">{{ ERT_Name }}</td>
                        <td style="text-align: center" colspan="2">
                            {{
                                resultList.CreateTime
                                    ? `${new Date(resultList.CreateTime).getFullYear()}年${new Date(resultList.CreateTime).getMonth() + 1}月`
                                    : ''
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { ExaminerReviewInfo } from '@/api/exam';
import TopNavBar from '@/components/TopNavBar.vue';
import domtoimage from 'dom-to-image';
import { Toast, ImagePreview } from 'vant';
export default {
    components: {
        TopNavBar,
    },
    data() {
        return {
            EF_ID: '',
            CertNO: '',
            resultList: [],
            UserInfo: null,
            ExamAnswerSheets: null,
            resultCode: [
                { ERT_Code: 4, ERT_Name: '优秀' },
                { ERT_Code: 3, ERT_Name: '良好' },
                { ERT_Code: 2, ERT_Name: '及格' },
                { ERT_Code: 1, ERT_Name: '不及格' },
                { ERT_Code: 0, ERT_Name: '缺考' },
            ],
            ERT_Name: '',
            ScoreList: null,
            IsMusicTheory: false,
            chin_list: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八'],
            SumScore: 0,
        };
    },
    created() {
        this.GetExamList();
    },
    methods: {
        GetExamList() {
            if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0 && this.$route.query.CertNO != undefined && this.$route.query.CertNO) {
                ExaminerReviewInfo({
                    EF_ID: this.$route.query.EF_ID,
                    CertNO: this.$route.query.CertNO,
                }).then(result => {
                    this.UserInfo = result.OtherMsg.UserInfo;
                    let index = 0;
                    let EQT_ID = 0;
                    this.resultList = result.item;
                    if (this.UserInfo.Majors.MID != 9) {
                        this.IsMusicTheory = false;
                        this.resultList.ExamAnswerSheets = this.resultList.ExamAnswerSheets.sort(this.sortIdAsc());
                        this.resultList.Judgement = JSON.parse(this.resultList.Judgement);
                        this.ExamAnswerSheets = this.resultList.ExamAnswerSheets;
                        this.resultList.ExamAnswerSheets.forEach(element => {
                            if (this.resultList.ExamAnswerSheets.filter(s => s.EQT_ID == element.EQT_ID).length > 1) {
                                if (EQT_ID != element.EQT_ID) {
                                    EQT_ID = element.EQT_ID;
                                    index = 0;
                                } else {
                                    index++;
                                }
                                element.ExamQuestionType.TypeName += `(${chin_list[index]})`;
                            }
                        });
                    } else {
                        this.IsMusicTheory = true;
                        var ScoreListTemp = JSON.parse(result.item.Judgement);
                        this.SumScore = 0;

                        var QuestionIds = result.OtherMsg.QuestionList.split(',');

                        let qq = [];

                        QuestionIds.forEach(qid => {
                            qq.push(
                                ScoreListTemp.filter(f => {
                                    return f.EMQ_ID == qid;
                                })[0]
                            );
                        });
                        this.ScoreList = qq;
                        this.ScoreList.forEach(element => {
                            this.SumScore += element.Score;
                        });
                    }

                    this.ERT_Name = this.resultCode.filter(s => s.ERT_Code == result.OtherMsg.ERT_Code)[0].ERT_Name;
                });
            } else {
                if (window.history.length <= 1) {
                    return;
                }
                if (this.$router.history.current.meta.BackUrl && this.$router.history.current.meta.BackUrl !== '') {
                    this.$router.push(
                        { name: this.$router.history.current.meta.BackUrl },
                        () => {},
                        () => {}
                    );
                } else {
                    this.$router.go(-1); //返回上一层
                }
            }
        },
        sortIdAsc() {
            return function (a, b) {
                var value1 = a.ExamQuestionType.Sort;
                var value2 = b.ExamQuestionType.Sort;
                return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
            };
        },
        printTable() {
            let node = document.getElementById('printTable');
            node.style.display = 'block';
            domtoimage
                .toPng(node)
                .then(dataUrl => {
                    console.log(dataUrl);
                    node.style.display = 'none';
                    ImagePreview({
                        images: [dataUrl],
                        closeable: true,
                    });
                })
                .catch(function (error) {
                    Toast.fail('生成评语失败，请稍后再试');
                    node.style.display = 'none';
                });
        },
    },
};
</script>

<style>
.SRcontainer {
    width: 96%;
    margin: 2%;
    box-sizing: border-box;
    background: #fff;
}
.SRht {
    font-size: 28px;
    font-weight: bold;
}
.SRht2 {
    font-size: 24px;
    letter-spacing: 20px;
}
.SRcontainer tr td {
    padding: 5px;
    font-size: 14px;
}
.SRcontainer tr td {
    text-align: center;
    padding: 15px 0;
}
.SRcontainer tr td .van-icon {
    color: #ee0a24;
    font-size: 24px;
}
.SRcontainer .sitem .SRtitle {
    background: #fff;
    color: #333;
    font-weight: bold;
}
.succeed {
    background: #07c160;
    color: #fff;
}
.warning {
    background: #ff976a;
    color: #fff;
}
.danger {
    background: #ee0a24;
    color: #fff;
}
.w7 {
    width: 7%;
}
</style>